import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { BaseApiService } from '../../core/services/base-api.service';
import { HolyQuranBaseDto } from '../../types/api.types';

@Injectable({ providedIn: 'root' })
export class BiblioDetailService extends BaseApiService {
  protected override basePath = '/api';

  fetchBiblio(id: number): Observable<HolyQuranBaseDto> {
    return this.http.get<HolyQuranBaseDto>(`${this.basePath}/HolyQuran/${id}`);
  }

  fetchItems(biblioId: number): Observable<any[]> {
    return of([]);
  }
}
